module.exports = __webpack_public_path__ + "static/brian-1608d99afd03eebb9757844935293cc3.jpg";